export const PODER_TODOS = 100;
export const PODER_PAGAMENTO = 1;
export const PODER_PAGAMENTO_E_RETIRADA = 2;

export const Poderes = {
  [PODER_TODOS]: {title: 'Todos', class: 'representante-poder-' + PODER_TODOS},
  [PODER_PAGAMENTO]: {title: 'Pagamento', class: 'representante-poder-' + PODER_PAGAMENTO},
  [PODER_PAGAMENTO_E_RETIRADA]: {title: 'Pagamento, Retirada', class: 'representante-poder-' + PODER_PAGAMENTO_E_RETIRADA}
}
